import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { defaultConfig } from 'config/default'
import { downloadAs } from 'utils/downloadFile'

export const useExportBulkMutation = (
	ids: number[],
	exportFormat: string | number | null,
	onSettled: () => void
) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportBulkMutation, isPending: isExportLoading } = useMutation({
		mutationFn: () => {
			// TODO: use apiRoute
			return axiosPrivate.post(
				'/tags/export/',
				{ ids, format: exportFormat },
				{ responseType: 'arraybuffer' }
			)
		},
		onSuccess: (res) => {
			const format = defaultConfig.exportFormatOptions
				.find((format) => format.value === exportFormat)
				?.label.toLowerCase()

			if (format) {
				downloadAs({ file: res.data, name: 'tags-export', format })
			}

			useToast({
				type: 'success',
				message: t('Tags exported')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		exportBulkMutation,
		isExportLoading
	}
}
